import { useEffect } from "react";
import "./PortfolioCategoryPlaceholder.css";

export default function PortfolioCategoryPlaceholder({
  config,
  embed = false,
  onActiveChange,
}) {
  useEffect(() => {
    onActiveChange?.(config.default);
  }, [config, onActiveChange]);

  return (
    <div
      className={`portfolio-placeholder${embed ? " portfolio-placeholder--embed" : ""}`}
      data-testid={`${config.testId}-placeholder`}
      style={{ "--ph-accent": config.accent }}
    >
      <div className="portfolio-placeholder__inner">
        <span className="portfolio-placeholder__eyebrow">PORTFOLIO</span>
        <h3 className="portfolio-placeholder__title">{config.default.title}</h3>
        <p className="portfolio-placeholder__lead">{config.placeholderLead}</p>
        <p className="portfolio-placeholder__note">제작 사례 스크린샷을 준비 중입니다.</p>
      </div>
    </div>
  );
}
